// extracted by mini-css-extract-plugin
module.exports = {"children":"async_children__X7bi_","loadingIcon":"async_loadingIcon__Bxhh6","loading":"async_loading__Q72vd"};